import React, { forwardRef, RefObject } from 'react';

import { clsx } from 'clsx';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';

import { useScrollDownToast } from 'src/hooks/useScrollDownToast';

import { MAIN_SCREEN_ANCHOR_KEY } from './../../constants';

import styles from './MainScreen.scss';

const MainScreen = forwardRef<
  HTMLDivElement,
  { formRef: RefObject<HTMLDivElement | null>; travelLoyaltyRef: RefObject<HTMLDivElement | null> }
>((props, ref) => {
  const { isDesktop } = useLayoutContext();
  const scrollButtonClick = (targetRef: RefObject<HTMLDivElement | null>) => {
    targetRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const { ref: inViewRef } = useScrollDownToast<HTMLParagraphElement>({
    toastClassName: styles.scrollDownText,
    onClick: () => scrollButtonClick(props.travelLoyaltyRef),
    anchor: MAIN_SCREEN_ANCHOR_KEY,
    componentClassName: styles.scrollDownButton,
    containerClassName: styles.messageContainer,
  });

  return (
    <section data-locator="partnersMainScreen" className={styles.mainScreenContainer} ref={ref}>
      <FadeIn delay={0.2}>
        <p className={styles.mainScreenTitle}>Empower your business</p>
        <p className={clsx(styles.mainScreenTitle, styles.mainScreenTitleThin)} ref={inViewRef}>
          with travel loyalty
        </p>
      </FadeIn>
      <FadeIn delay={0.4} className={styles.subTitle}>
        All-in-one platform for bookings
        {isDesktop ? ' ' : <br />}and rewards that keeps
        {isDesktop ? <br /> : ' '}your customers
        {isDesktop ? ' ' : <br />}coming back and spending more
      </FadeIn>
      <FadeIn delay={0.6}>
        <button className={styles.button} onClick={() => scrollButtonClick(props.formRef)}>
          Schedule a demo
        </button>
      </FadeIn>
    </section>
  );
});

export default MainScreen;
